var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruckBlueBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 165,
    height: 114,
    viewBox: "0 0 165 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "truck-blue-bg",
    transform: "translate(-44 -1328)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    width: 165,
    height: 114,
    rx: 20,
    transform: "translate(44 1328)",
    fill: "#04a8e8"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Truck",
    transform: "translate(103 1419)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600,
    letterSpacing: "0.035em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "TRUCK")), /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271",
    transform: "translate(-1482.624 -1352.188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M1635.362,2738.387c4.465-3.958,9.262-5.822,14.947-4.127,1.172.349,2.677.662,3.32,1.521,2.807,3.756,6.725,4.013,10.937,3.654,1.139,3.114.388,6.092.527,9,.062,1.295-.9,1.652-2,1.66-2.206.014-4.412,0-6.646,0,0-1.423-.013-2.4,0-3.371a10.045,10.045,0,1,0-20.077-.006,11.1,11.1,0,0,0,.166,1.481c.148.93.2,1.808-1.092,1.861-1.2.048-1.478-.662-1.3-1.7a9.163,9.163,0,0,0,.193-1.1c.283-6.09-3.876-10.8-9.662-10.957-5.964-.16-10.264,4.087-10.375,10.259-.017.972,0,1.947,0,3.245h-39.8c.668-4.343.586-8.516-3.092-11.569a9.832,9.832,0,0,0-6.845-2.461c-6.334.234-9.011,3.983-9.827,13.955-3.057.979-4.774.045-4.656-3.359.093-2.654-.059-5.159,1.29-7.868,1.15-2.31.428-5.593.4-8.445-.055-4.963-.264-9.716,3.544-13.954,1.7-1.9,2.036-5.305,2.354-8.1.695-6.1,4.744-9.1,9.819-10.9,10.445-3.707,21.264-3.215,32.075-2.157,2.768.271,2.805,2.3,2.8,4.4q-.019,17.528-.006,35.058c0,4.977.007,4.942,4.838,5.026,3.479.059,6.491-.1,9.418-2.969,4.085-4.009,10.757-3.761,15.505-.478C1633.13,2736.691,1634.107,2737.456,1635.362,2738.387Zm-77.394-21.075c4.1,0,7.656-.01,11.212.007,1.017.005,1.782-.43,1.782-1.436,0-3.43,1.2-7.288-.477-10.144-1.226-2.089-4.834-.519-7.357-.818-2.177-.261-3.073.65-3.359,2.8C1559.368,2710.759,1558.653,2713.759,1557.968,2717.312Zm15.042-.189c4.5-3.615,7.263-7.088,8.063-11.859-1.36-.949-2.63-.456-3.816-.614-3.145-.418-4.6.75-4.29,4.1C1573.192,2711.164,1573.01,2713.613,1573.01,2717.122Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    d: "M1572.652,2746.076c-.076,3.933-4.111,8.052-7.822,7.982-3.97-.075-7.666-4.022-7.629-8.148a7.705,7.705,0,0,1,7.957-7.612A7.909,7.909,0,0,1,1572.652,2746.076Z",
    transform: "translate(-0.034 -0.212)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M1624.793,2754.4a7.965,7.965,0,0,1-7.889-7.75,7.706,7.706,0,0,1,15.409-.34A7.929,7.929,0,0,1,1624.793,2754.4Z",
    transform: "translate(-0.321 -0.214)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    d: "M1646.82,2754.4a8.2,8.2,0,0,1-7.732-7.937,7.73,7.73,0,0,1,15.46.021A8.16,8.16,0,0,1,1646.82,2754.4Z",
    transform: "translate(-0.427 -0.214)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckBlueBg);
export default __webpack_public_path__ + "static/media/truck-blue-bg.580e5bc3c4a1bca0b9bf569e93118851.svg";
export { ForwardRef as ReactComponent };